import { render, staticRenderFns } from "./DepartmentView.vue?vue&type=template&id=6ac102e6&scoped=true"
import script from "./DepartmentView.vue?vue&type=script&lang=ts"
export * from "./DepartmentView.vue?vue&type=script&lang=ts"
import style0 from "./DepartmentView.vue?vue&type=style&index=0&id=6ac102e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac102e6",
  null
  
)

export default component.exports